import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import TableWallet from "../../walletReports/table";
/**
 * Content
 *
 * نمایش لیست خریدهای اعتباری مشتری در قالب جدول.
 *
 * @remarks
 * - از `TableWallet` برای نمایش جدول خریدهای اعتباری استفاده شده است.
 * - `dataHeader` شامل ستون‌های جدول مانند خرید اعتباری، کل اقساط، مبلغ پرداختی هر قسط، مبلغ باقیمانده، تاریخ دریافت و پایان اعتبار و پذیرنده است.
 * - متن توضیحی برای کاربر بالای جدول قرار دارد تا نحوه استفاده و اطلاعات جدول را توضیح دهد.
 * - از `StackKit` و `TypoGraphyKit` برای چینش و استایل‌بندی متن و جدول استفاده شده است.
 * - `fakeData` به عنوان داده نمونه برای جدول استفاده شده است و می‌تواند با داده واقعی جایگزین شود.
 *
 * @returns JSX.Element
 * جدول خریدهای اعتباری همراه با توضیحات برای کاربر.
 */

const Content = () => {
  const dataHeader = [
    { id: "id", title: "خرید اعتباری" },
    { id: "datetime", title: "کل اقساط" },
    { id: "amount", title: "اقساط پرداخت شده" },
    { id: "type", title: "مبلغ پرداختی هر قسط" },
    { id: "test", title: "مبلغ باقیمانده" },
    { id: "moreElement", title: "مبلغ تسویه یکجا" },
    { id: "buttonDetail", title: "تاریخ دریافت اعتبار" },
    { id: "test", title: "تاریخ پایان اعتبار" },
    { id: "test", title: "پذیرنده دریافت کننده اعتبار" },
  ];
  const fakeData: any = [];
  return (
    <>
      <StackKit alignItems={"start"} sx={{ padding: "0 15px" }}>
        <TypoGraphyKit variant="body1">کاربر گرامی</TypoGraphyKit>
        <TypoGraphyKit variant="body1" sx={{ direction: "ltr !important", textAlign: "right" }}>
          در لیست زیر شما میتوانید اعتباراتی که از فروشگاه ها دریافت کرده اید را
          مشاهده کنید. شما میتوانید با مشاهده جزئیات اعتبار ؛ باقیمانده موجودی
          اعتباری در همان فروشگاه و یا اقساط خرید هایی که قبلا از فروشگاه انجام
          داده اید را مشاهده کنید
        </TypoGraphyKit>
        <TableWallet dataHeader={dataHeader} dataTbody={fakeData} />
      </StackKit>
    </>
  );
};

export default Content;
